import { Route } from "react-router";
import {
  my_routes,
  public_routes,
  student_routes,
  prof_routes,
  parent_routes,
} from "./all_routes";
import Login from "../auth/login/login";
import ForgotPassword from "../auth/forgotPassword/forgotPassword";
import ResetPassword from "../auth/resetPassword/resetPassword";
import ChangePassword from "../auth/changePassword/changePassword";
import CreateUser from "../user/createUser";
import EditUser from "../user/editUser";
import AllUser from "../user/allUser";
import RolesPermission from "../user/rolesPermission";

import AllParent from "../parents/allParent";

import AllStudent from "../students/allStudent";
import StudentRegistration from "../students/studentRegistration";
import EditStudentRegistration from "../students/editStudentRegistration";
import StudentDetailsPage from "../students/studentDetailsPage";

import AllTeacher from "../teachers/allTeachers";
import CreateTeacher from "../teachers/createTeacher";
import EditTeacher from "../teachers/editTeacher";
import TeacherDetailsPage from "../teachers/teacherDetailsPage";
import HourlyRateTeacher from "../teachers/hourlyRate";

import NoteTable from "../notes/noteList";
import StudentNoteList from "../notes/student/studentNoteList";
import ExternalNote from "../notes/externalNote";

import EvaluationList from "../pedagogicElement/evaluations/evaluationList";

// Les Dashboards Page
import AdminDashboard from "../user/admin/adminDashboard";
import StudentDashboard from "../students/student/studentDashboard";
import ParentDashboard from "../parents/parent/parentDashBoard";
import TeacherDashboard from "../teachers/teacher/teacherDashboard";

import Profile from "../pages/profile";
import StudentProfile from "../students/student/profile";
import TeacherProfile from "../teachers/teacher/profile";

import LockScreen from "../auth/lockScreen";

import AcademicYearList from "../generalParam/academicYear/academicYearList";
import LevelList from "../pedagogicElement/level/levelList";
import ClassroomList from "../pedagogicElement/classroom/classroomList";
import SubjectList from "../pedagogicElement/subject/subjecList";
import ClassList from "../pedagogicElement/class/classList";
import DepartmentList from "../user/department/departmentList";
import EvaluationPeriodList from "../generalParam/evaluationPeriod/evaluationPeriodList";
import UeList from "../evaluation/ue/ueList";

import AllDocs from "../docs/allDocs";
import {
  Action,
  buildPermission,
  Resource,
} from "../../core/common/autorisations/permissionsMap";
import Settings from "../generalParam/setting/settings";
import EdtManager from "../edt/edt_manager";
import EdtList from "../edt/edt_list";
import CoursList from "../edt/cours/coursList";
import MonthlyReport from "../teachers/report/MonthlyReport";
import StudentAbsencePage from "../students/absences";
import SanctionPage from "../students/sanctions";
import StudentEDT from "../students/student/edt";
import StudentCourse from "../students/student/course";
import CourseDetails from "../students/student/course/courseDetails";
import StudentAttendance from "../students/student/attendance";
import StudentNote from "../students/student/note";
import ClassementByClass from "../classements/classementByClass";
import ClassementByPromotion from "../classements/classementByPromotion";
import MessageManagerPage from "../messages";
import TeacherCourse from "../teachers/teacher/course";
import TeacherCourseDetails from "../teachers/teacher/course/courseDetails";
import TeacherEDT from "../teachers/teacher/edt";
import FinanceHome from "../finance";
import PaymentPlan from "../finance/paymentPlan";
import RestrictionNote from "../notes/restriction";
import PaymentList from "../finance/payment/paymentList";
import RequestList from "../request";
import RequestDetails from "../request/requestDetails";
import StudentRequestList from "../students/student/request";
import StudentPaymentList from "../students/student/payment";
import MemoryList from "../memory";
import MemoryDetails from "../memory/memoryDetails";
import ClaimList from "../claim";
import StudentClaimList from "../students/student/claim";
import BourseAndRemise from "../finance/bourse_remise";
import StudentExamList from "../students/student/exam";
import StudentExamDetails from "../students/student/exam/ExamDetails";
import PlanningExam from "../examPlanning";
import CreateClaim from "../students/student/claim/createClaim";
import StudentClaimDetail from "../students/student/claim/claimDetail";
import ClaimDetails from "../claim/claimDetails";
import VisitorsPage from "../visiteurs";
import DecisionList from "../diplome/DecisionList";
import DecisionDetails from "../diplome/decisionDetails";

import StudentMessagePage from "../students/student/message";
import TeacherMessagePage from "../teachers/teacher/message";
import DiplomeList from "../diplome/diplomeList";
import DiplomeDetails from "../diplome/DiplomeDetails";

import ParentProfile from "../parents/parent/profile";
import StudentEDTViewParent from "../parents/parent/edt";
import StudentCourseViewParent from "../parents/parent/course";
import CourseDetailsViewParent from "../parents/parent/course/courseDetails";
import StudentNoteViewParent from "../parents/parent/note";
import StudentAttendanceViewParent from "../parents/parent/attendance";
import StudentPaymentListViewParent from "../parents/parent/payment";
import StudentExamListViewParent from "../parents/parent/exam";
import StudentExamDetailsViewParent from "../parents/parent/exam/ExamDetails";
import ParentMessagePage from "../parents/parent/message";
import StudentClaimListViewParent from "../parents/parent/claim";
import StudentClaimDetailViewParent from "../parents/parent/claim/claimDetail";
import StudentRequestListViewParent from "../parents/parent/request";
import Trombinoscope from "../avatar/Trombinoscope";
import EventsManager from "../event";

const my_route = my_routes;
const public_route = public_routes;
const student_route = student_routes;
const parent_route = parent_routes;
const prof_route = prof_routes;

export const otherRoutes = [
  {
    path: public_route.home,
    element: <Login />,
    route: Route,
    permissions: [], // Add permissions if needed
  },
  {
    path: public_route.login,
    element: <Login />,
    route: Route,
    permissions: [], // Add permissions if needed
  },
  {
    path: public_route.forgotPassword,
    element: <ForgotPassword />,
    route: Route,
    permissions: [], // Add permissions if needed
  },
  {
    path: public_route.resetPassword,
    element: <ResetPassword />,
    route: Route,
    permissions: [], // Add permissions if needed
  },
  {
    path: public_route.lockScreen,
    element: <LockScreen />,
    route: Route,
    permissions: [], // Add permissions if needed
  },
];

export const privateRoutesUser = [
  // Gestion des utilisateurs
  {
    path: my_route.newUser,
    element: <CreateUser />,
    route: Route,
    permissions: [buildPermission(Resource.USER, Action.CREATE)], // Add permissions if needed
  },
  {
    path: my_route.editUser,
    element: <EditUser />,
    route: Route,
    permissions: [buildPermission(Resource.USER, Action.UPDATE)], // Add permissions if needed
  },
  {
    path: my_route.allUser,
    element: <AllUser />,
    route: Route,
    permissions: [
      // utilisateur (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.USER, action),
      ),
    ], // Add permissions if needed
  },
  {
    path: my_route.department,
    element: <DepartmentList />,
    route: Route,
    permissions: [
      // mutilisateur (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.DEPARTMENT, action),
      ),
    ], // Add permissions if needed
  },
  {
    path: my_route.rolesPermissions,
    element: <RolesPermission />,
    route: Route,
    permissions: [
      // permissions (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.PERMISSIONS, action),
      ),
    ], // Add permissions if needed
  },
  {
    path: my_route.profile,
    element: <Profile />,
    route: Route,
    permissions: [], // Add permissions if needed
  },
  {
    path: my_route.changePassword,
    element: <ChangePassword />,
    route: Route,
    permissions: [], // Add permissions if needed
  },

  // Gestion des parents
  {
    path: my_route.allParent,
    element: <AllParent />,
    route: Route,
    permissions: [
      // parent (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.PARENT, action),
      ),
    ], // Add permissions if needed
  },

  // Gestion des etudiants
  {
    path: my_route.allStudent,
    element: <AllStudent />,
    route: Route,
    permissions: [
      // etudiant (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.STUDENT, action),
      ),
    ], //Add permissions if needed
  },
  {
    path: my_route.registrationStudent,
    element: <StudentRegistration />,
    route: Route,
    permissions: [buildPermission(Resource.STUDENT, Action.CREATE)], // Add permissions if needed
  },
  {
    path: my_route.editStudent,
    element: <EditStudentRegistration />,
    route: Route,
    permissions: [buildPermission(Resource.STUDENT, Action.UPDATE)], // Add permissions if needed
  },
  {
    path: my_route.studentDetailsPage,
    element: <StudentDetailsPage />,
    route: Route,
    pemissions: [buildPermission(Resource.STUDENT, Action.READ)], // Add permissions if needed
  },
  {
    path: my_route.studentAbsence,
    element: <StudentAbsencePage />,
    route: Route,
    permissions: [
      // etudiant (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.STUDENT_ABSENCE, action),
      ),
    ], //Add permissions if needed
  },
  {
    path: my_route.sanctions,
    element: <SanctionPage />,
    route: Route,
    permissions: [buildPermission(Resource.STUDENT_SANCTION, Action.READ)], // Add permissions if needed
  },
  // Gestion des professeurs
  {
    path: my_route.allTeacher,
    element: <AllTeacher />,
    route: Route,
    permissions: [
      // professeur (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.TEACHER, action),
      ),
    ], // Add permissions if needed
  },
  {
    path: my_route.createTeacher,
    element: <CreateTeacher />,
    route: Route,
    permissions: [buildPermission(Resource.TEACHER, Action.CREATE)], // Add permissions if needed
  },
  {
    path: my_route.editTeacher,
    element: <EditTeacher />,
    route: Route,
    permissions: [buildPermission(Resource.TEACHER, Action.UPDATE)], // Add permissions if needed
  },
  {
    path: my_route.teacherDetailsPage,
    element: <TeacherDetailsPage />,
    route: Route,
    permissions: [buildPermission(Resource.TEACHER, Action.READ)], // Add permissions if needed
  },
  {
    path: my_route.hourlyRateTeacher,
    element: <HourlyRateTeacher />,
    route: Route,
    permissions: [buildPermission(Resource.HOURLYRATE_TEACHER, Action.READ)], // Add permissions if needed
  },
  {
    path: my_route.teacherReport,
    element: <MonthlyReport />,
    route: Route,
    permissions: [
      // teahcer-report (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.TEACHER_REPORT, action),
      ),
    ], // Add permissions if needed
  },
  // Gestion des notes
  {
    path: my_route.allNotes,
    element: <NoteTable />,
    route: Route,
    permissions: [
      // note (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.NOTE, action),
      ),
    ], // Add permissions if needed
  },
  {
    path: my_route.studentNotes,
    element: <StudentNoteList />,
    route: Route,
    permissions: [
      // note (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.NOTE, action),
      ),
    ], // Add permissions if needed
  },

  // Gestion des classements
  {
    path: my_route.classementByClass,
    element: <ClassementByClass />,
    route: Route,
    permissions: [
      // classement (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.NOTE, action),
      ),
    ], // Add permissions if needed
  },
  {
    path: my_route.classementByPromotion,
    element: <ClassementByPromotion />,
    route: Route,
    permissions: [
      // classement (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.NOTE, action),
      ),
    ], // Add permissions if needed
  },
  {
    path: my_route.noteExterne,
    element: <ExternalNote />,
    route: Route,
    permissions: [
      // note (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.EXTERNAL_NOTE, action),
      ),
    ], // Add permissions if needed
  },
  // Gestion des évaluations
  {
    path: my_route.evaluationList,
    element: <EvaluationList />,
    route: Route,
    permissions: [
      // evaluation (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.EVALUATION, action),
      ),
    ], // Add permissions if needed
  },
  {
    path: my_route.academicYear,
    element: <AcademicYearList />,
    route: Route,
    permissions: [
      // année academique (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.ACADEMIC_YEAR, action),
      ),
    ], // Add permissions if needed
  },
  {
    path: my_route.levelList,
    element: <LevelList />,
    route: Route,
    permissions: [
      // niveau academique (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.LEVEL, action),
      ),
    ], // Add permissions if needed
  },
  {
    path: my_route.classroomList,
    element: <ClassroomList />,
    route: Route,
    permissions: [
      // salle academique (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.CLASSROOM, action),
      ),
    ], // Add permissions if needed
  },
  {
    path: my_route.subjectList,
    element: <SubjectList />,
    route: Route,
    permissions: [
      // matiere (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.SUBJECT, action),
      ),
    ], // Add permissions if needed
  },
  {
    path: my_route.classList,
    element: <ClassList />,
    route: Route,
    permissions: [
      // classe (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.CLASS, action),
      ),
    ], // Add permissions if needed
  },
  {
    path: my_route.evaluationPeriod,
    element: <EvaluationPeriodList />,
    route: Route,
    permissions: [
      // evaluation (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.EVALUATION, action),
      ),
    ], // Add permissions if needed
  },
  {
    path: my_route.ue,
    element: <UeList />,
    route: Route,
    permissions: [
      // UE (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.UE, action),
      ),
    ], // Add permissions if needed
  },
  {
    path: my_route.settings,
    element: <Settings />,
    route: Route,
    permissions: [
      // setting (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.CALCULATION_METHODS, action),
      ),
    ], // Add permissions if needed
  },
  {
    path: my_route.docs,
    element: <AllDocs />,
    route: Route,
    permissions: [
      // frequentation (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.FREQUENTATION, action),
      ),
      // emargement (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.EMARGEMENT, action),
      ),
    ], // Add permissions if needed
  },

  // Dashboard des ressources
  {
    path: my_route.adminDashboard,
    element: <AdminDashboard />,
    route: Route,
    permissions: [], // Add permissions if needed
  },
  {
    path: my_route.home,
    element: <AdminDashboard />,
    route: Route,
    permissions: [], // Add permissions if needed
  },

  // Gestion EDT
  {
    path: my_route.timeTableManager,
    element: <EdtManager />,
    route: Route,
    permissions: [
      // emplois du temps (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.EDT, action),
      ),
    ], // Add permissions if needed
  },
  {
    path: my_route.timeTableList,
    element: <EdtList />,
    route: Route,
    permissions: [
      // emplois du temps (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.EDT, action),
      ),
    ], // Add permissions if needed
  },
  {
    path: my_route.coursList,
    element: <CoursList />,
    route: Route,
    permissions: [
      // cours (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.COURSE, action),
      ),
    ], // Add permissions if needed
  },

  // Gestion des messages
  {
    path: my_route.messagePage,
    element: <MessageManagerPage />,
    route: Route,
    permissions: [
      // message (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.MESSAGE, action),
      ),
    ], // Add permissions if needed
  },
  {
    path: my_route.financeHome,
    element: <FinanceHome />,
    route: Route,
    permissions: [
      // bourse/remise (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.BOURSE_REMISE, action),
      ),

      // banque (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.PAYMENT_SETTING, action),
      ),

      // plan de paiement (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.PAYMENT_PLAN, action),
      ),

      // plan de paiement des étudiants (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.STUDENT_PAYMENT_PLAN, action),
      ),

      // paiement (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.PAYMENT, action),
      ),

      // paramètres de paiement (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.PAYMENT_SETTING, action),
      ),

      // restriction de note (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.NOTE_RESTRICTION, action),
      ),
    ], // Add permissions if needed
  },
  {
    path: my_route.PaymentPlan,
    element: <PaymentPlan />,
    route: Route,
    permissions: [
      // plan de paiement (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.PAYMENT_PLAN, action),
      ),
    ], // Add permissions if needed
  },
  {
    path: my_route.restrictionNote,
    element: <RestrictionNote />,
    route: Route,
    permissions: [
      // restriction de note (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.NOTE_RESTRICTION, action),
      ),
    ], // Add permissions if needed
  },
  {
    path: my_route.allPayment,
    element: <PaymentList />,
    route: Route,
    permissions: [
      // paiement (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.PAYMENT, action),
      ),
    ], // Add permissions if needed
  },
  {
    path: my_route.requestList,
    element: <RequestList />,
    route: Route,
    permissions: [], // Assigned personnel are authorized per request by the backend.
  },
  {
    path: my_route.requestDetails,
    element: <RequestDetails />,
    route: Route,
    permissions: [], // Assigned personnel are authorized per request by the backend.
  },
  {
    path: my_route.memoryList,
    element: <MemoryList />,
    route: Route,
    permissions: [
      // memoire (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.MEMOIRE, action),
      ),
    ], // Add permissions if needed
  },
  {
    path: my_route.memoryDetails,
    element: <MemoryDetails />,
    route: Route,
    permissions: [
      // memoire (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.MEMOIRE, action),
      ),
    ], // Add permissions if needed
  },
  {
    path: my_route.claimList,
    element: <ClaimList />,
    route: Route,
    permissions: [
      // reclamation (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.CLAIM, action),
      ),
    ], // Add permissions if needed
  },
  {
    path: my_route.claimDetails,
    element: <ClaimDetails />,
    route: Route,
    permissions: [
      // reclamation (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.CLAIM, action),
      ),
    ], // Add permissions if needed
  },
  {
    path: my_route.bourseAndRemise,
    element: <BourseAndRemise />,
    route: Route,
    permissions: [
      // bourse/remise (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.BOURSE_REMISE, action),
      ),
    ], // Add permissions if needed
  },
  {
    path: my_route.planingExam,
    element: <PlanningExam />,
    route: Route,
    permissions: [
      // planning d'examen (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.EDTE, action),
      ),
    ], // Add permissions if needed
  },
  {
    path: my_route.visitorList,
    element: <VisitorsPage />,
    route: Route,
    permissions: [
      // visiteurs (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.VISITOR, action),
      ),
    ], // Add permissions if needed
  },
  {
    path: my_route.decisionList,
    element: <DecisionList />,
    route: Route,
    permissions: [
      // diplome (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.DIPLOME, action),
      ),
    ], // Add permissions if needed
  },
  {
    path: my_route.decisionDetails,
    element: <DecisionDetails />,
    route: Route,
    permissions: [
      // diplome (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.DIPLOME, action),
      ),
    ], // Add permissions if needed
  },
  {
    path: my_route.diplomeList,
    element: <DiplomeList />,
    route: Route,
    permissions: [
      // diplome (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.DIPLOME, action),
      ),
    ], // Add permissions if needed
  },
  {
    path: my_route.diplomeDetails,
    element: <DiplomeDetails />,
    route: Route,
    permissions: [
      // diplome (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.DIPLOME, action),
      ),
    ], // Add permissions if needed
  },
  {
    path: my_route.trombinoscope,
    element: <Trombinoscope />,
    route: Route,
    permissions: [
      // etudiant (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.STUDENT, action),
      ),
    ], //Add permission if needed
  },
  {
    path: my_route.eventPage,
    element: <EventsManager />,
    route: Route,
    permissions: [
      // etudiant (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.EVENT, action),
      ),
    ], //Add permission if needed
  },
];

// routes spécifique au profil étudiant
export const privateRoutesStudent = [
  {
    path: student_route.studentDashboard,
    element: <StudentDashboard />,
    route: Route,
    permissions: [], // Add permissions if needed
  },
  {
    path: student_route.home,
    element: <StudentDashboard />,
    route: Route,
    permissions: [], // Add permissions if needed
  },
  {
    path: student_route.studentEDT,
    element: <StudentEDT />,
    route: Route,
    permissions: [], // Add permissions if needed
  },
  {
    path: student_route.studentCourse,
    element: <StudentCourse />,
    route: Route,
    permissions: [], // Add permissions if needed
  },
  {
    path: student_route.courseDetails,
    element: <CourseDetails />,
    route: Route,
    permissions: [], // Add permissions if needed
  },
  {
    path: student_route.studentAttendance,
    element: <StudentAttendance />,
    route: Route,
    permissions: [], // Add permissions if needed
  },
  {
    path: student_route.studentNote,
    element: <StudentNote />,
    route: Route,
    permissions: [], // Add permissions if needed
  },
  {
    path: student_route.profile,
    element: <StudentProfile />,
    route: Route,
    permissions: [], // Add permissions if needed
  },
  {
    path: student_route.requestList,
    element: <StudentRequestList />,
    route: Route,
    permissions: [], // Add permissions if needed
  },
  {
    path: student_route.paymentList,
    element: <StudentPaymentList />,
    route: Route,
    permissions: [], // Add permissions if needed
  },
  {
    path: student_route.myClaims,
    element: <StudentClaimList />,
    route: Route,
    permissions: [], // Add permissions if needed
  },

  {
    path: student_route.createClaim,
    element: <CreateClaim />,
    route: Route,
    permissions: [], // Add permissions if needed
  },

  {
    path: student_route.claimDetails,
    element: <StudentClaimDetail />,
    route: Route,
    permissions: [], // Add permissions if needed
  },

  {
    path: student_route.myExams,
    element: <StudentExamList />,
    route: Route,
    permissions: [], // Add permissions if needed
  },
  {
    path: student_route.examDetails,
    element: <StudentExamDetails />,
    route: Route,
    permissions: [], // Add permissions if needed
  },
  // Gestion des messages
  {
    path: my_route.messagePage,
    element: <StudentMessagePage />,
    route: Route,
    permissions: [], // Add permissions if needed
  },
];

// routes spécifique au profil parent
export const privateRoutesParent = [
  {
    path: parent_route.parentDashboard,
    element: <ParentDashboard />,
    route: Route,
    permissions: [], // Add permissions if needed
  },
  {
    path: parent_route.home,
    element: <ParentDashboard />,
    route: Route,
    permissions: [], // Add permissions if needed
  },
  {
    path: parent_route.profile,
    element: <ParentProfile />,
    route: Route,
    permissions: [], // Add permissions if needed
  },
  {
    path: parent_route.studentEDT,
    element: <StudentEDTViewParent />,
    route: Route,
    permissions: [], // Add permissions if needed
  },
  {
    path: parent_route.studentCourse,
    element: <StudentCourseViewParent />,
    route: Route,
    permissions: [], // Add permissions if needed
  },
  {
    path: parent_route.courseDetails,
    element: <CourseDetailsViewParent />,
    route: Route,
    permissions: [], // Add permissions if needed
  },
  {
    path: parent_route.studentNote,
    element: <StudentNoteViewParent />,
    route: Route,
    permissions: [], // Add permissions if needed
  },
  {
    path: parent_route.studentAttendance,
    element: <StudentAttendanceViewParent />,
    route: Route,
    permissions: [], // Add permissions if needed
  },
  {
    path: parent_route.paymentList,
    element: <StudentPaymentListViewParent />,
    route: Route,
    permissions: [], // Add permissions if needed
  },
  // Gestion des examens
  {
    path: parent_route.childExams,
    element: <StudentExamListViewParent />,
    route: Route,
    permissions: [], // Add permissions if needed
  },
  {
    path: parent_route.examDetails,
    element: <StudentExamDetailsViewParent />,
    route: Route,
    permissions: [], // Add permissions if needed
  },
  // Gestion des demandes
  {
    path: parent_route.requestList,
    element: <StudentRequestListViewParent />,
    route: Route,
    permissions: [], // Add permissions if needed
  },
  // gestion des reclamations
  {
    path: parent_route.claims,
    element: <StudentClaimListViewParent />,
    route: Route,
    permissions: [], // Add permissions if needed
  },
  {
    path: parent_route.claimDetails,
    element: <StudentClaimDetailViewParent />,
    route: Route,
    permissions: [], // Add permissions if needed
  },
  // Gestion des messages
  {
    path: parent_route.messagePage,
    element: <ParentMessagePage />,
    route: Route,
    permissions: [], // Add permissions if needed
  },
];
// routes spécifique au profil professeur
export const privateRoutesTeacher = [
  {
    path: prof_routes.teacherDashboard,
    element: <TeacherDashboard />,
    route: Route,
    permissions: [], // Add permissions if needed
  },
  {
    path: prof_routes.teacherCourse,
    element: <TeacherCourse />,
    route: Route,
    permissions: [], // Add permissions if needed
  },
  {
    path: prof_route.teacherCourseDetails,
    element: <TeacherCourseDetails />,
    route: Route,
    permissions: [], // Add permissions if needed
  },
  {
    path: prof_route.teacherEDT,
    element: <TeacherEDT />,
    route: Route,
    permissions: [], // Add permissions if needed
  },
  {
    path: prof_route.profile,
    element: <TeacherProfile />,
    route: Route,
    permissions: [], // Add permissions if needed
  },
  // Gestion des messages
  {
    path: my_route.messagePage,
    element: <TeacherMessagePage />,
    route: Route,
    permissions: [], // Add permissions if needed
  },
];
